import React from 'react';
import PropTypes from 'prop-types';

import Button from 'ui/Button';

import TollIcon from '@mui/icons-material/Toll';

import { t } from "i18n/index";
import Label from 'ui/text/Label';

const RedeemButton = ({ onAction, loading, disableRedeemButton, points, available, timeToStart, isTicket, requires_approval, compact}) => {

  const showPoints = points > 0 && !isTicket;
  const fullwidth = !compact;

  return (
    <>
      <Button onClick={ onAction } smallPadded={isTicket || compact} fullwidth={fullwidth} loading={loading} disabled={disableRedeemButton} highlighted>
        {available
          ? <div className={`button-content ${!showPoints ? 'centered' : ''}`} >

              {showPoints && <div><TollIcon color='warning'/> {points}</div>}

              {isTicket
                ? requires_approval ? <span>{t('profile:perks:requestJoin')}</span> : <span>RSVP {t('literal:now')}</span>
                : <span>{t('literal:redeem')}</span>}

            </div>
          : timeToStart
            ? <span>{t('literal:availableIn', {timeToStart})}</span>
            : <span>{t('literal:soldOut')}</span>}
      </Button>
      {isTicket && !disableRedeemButton && !compact && <Label secondary small>{t('literal:freeEntrance')}</Label>}
    </>
  );
};

RedeemButton.propTypes = {
  onAction: PropTypes.func,
  loading: PropTypes.bool,
  disableRedeemButton: PropTypes.bool,
  points: PropTypes.number,
  available: PropTypes.bool,
  timeToStart: PropTypes.string,
  isTicket: PropTypes.bool,
  requires_approval: PropTypes.bool,
  compact: PropTypes.bool
};

export default RedeemButton;